define('view/controller/error/ErrorView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Error page view
     *
     * @class ErrorView
     */
    return LayoutView.extend({

        template: '#error_page',

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.additional_message = this.getOption('additionalMessage');
            result.type = this.getOption('type');

            return result;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'error',
                'error_type': this.getOption('type')
            });
        }

    });

});
